const enum FormStateEnum {
  Success = 'success',
  Error = 'error',
  Idle = 'idle',
  Loading = 'loading',
}

export default FormStateEnum;
